<template>
  <div class="page-frame" v-if="pageData" role="main">
    <div class="container">
      <div v-if="pageData.acf && pageData.acf['header_image']" class="header-image" role="banner">
        <v-img
          v-bind:src="pageData.acf['header_image'].url"
          v-bind:alt="pageData.acf['header_image'].alt"
          aspect-ratio="3"
        ></v-img>
      </div>
      <h1
        class="page-title"
        v-if="pageData.acf && pageData.acf['display_page_title']"
      >{{pageData.title.rendered}}</h1>
      <div v-html="pageData.content.rendered"></div>

      <section class="people">
        <v-layout wrap v-if="pageData.acf && pageData.acf.people && pageData.acf.people.length">
          <v-flex
            xs12
            sm6
            md4
            class="person"
            v-for="(person, index) in pageData.acf.people"
            :key="index"
          >
            <v-card v-bind:elevation="1" :dark="contrastMode" class="same-height">
              <div class="avatar-container">
                <v-avatar size="160" class="avatar">
                  <v-img
                    v-if="person.picture"
                    v-bind:src="person.picture.url"
                    v-bind:alt="person.picture.alt"
                  ></v-img>
                </v-avatar>
              </div>
              <v-card-title primary-title>
                <h3 class="name text-xs-center">{{person.full_name}}</h3>
              </v-card-title>
              <v-card-text>{{person.bio}}</v-card-text>
            </v-card>
          </v-flex>
        </v-layout>
      </section>
    </div>
  </div>
</template>

<script>
export default {
  name: "About",
  props: {
    pageData: Object,
    contrastMode: Boolean
  }
};
</script>

<style lang="scss">
.people {
  h2 {
    margin-bottom: 20px;
  }
}

.person {
  padding: 10px;
  .name {
    font-weight: bold;
    width: 100%;
  }
}

.same-height {
  height: 100%;
}

.avatar-container {
  display: flex;
  display: -webkit-flex;
  justify-content: center;
  -webkit-justify-content: center;
}

.avatar {
  margin-top: 16px;
}
</style>